import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { ScanConfigurationType } from '../company';

export enum ScanRuleConfigurationValueKey {
  ignoredRegex = 'ignoredRegex',
}

export enum ScanRuleType {
  ignoreScan = 'ignoreScan',
  ignoreValidation = 'ignoreValidation',
}

export class ScanRuleConfigurationValue {
  field: ScanConfigurationType = ScanConfigurationType.productNumber;
  key!: ScanRuleConfigurationValueKey;
  stringValue?: string;
  stringArrayValue: string[] = [];

  constructor(obj: any) {
    Object.assign(this, cloneDeep(obj));
  }
}

export class ScanRule extends CompanyEntity {
  type: ScanRuleType = ScanRuleType.ignoreScan;
  configurationValues: ScanRuleConfigurationValue[] = [
    new ScanRuleConfigurationValue({
      field: ScanConfigurationType.productNumber,
      key: ScanRuleConfigurationValueKey.ignoredRegex,
    }),
  ];

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}
